export default __webpack_public_path__ + "static/media/cpu-part.843c1333.png";